import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getExperienceType } from '../../../data/experienceTypes';
import { getExperienceTypeV2 } from '../../../data/experienceTypesV2';
import { getExperienceTypeIcon } from '../../../utils/experienceTypeIcons';
import { calculateProgress, getDaysUntil } from '../../../utils/experiences';

export default function ContinueExperienceCard({ experience }) {
  const navigate = useNavigate();
  const experienceType = getExperienceTypeV2(experience.typeId || experience.type) || getExperienceType(experience.type);
  const progress = calculateProgress(experience);
  const daysUntil = getDaysUntil(experience);

  return (
    <motion.div
      whileHover={{ y: -6 }}
      transition={{ duration: 0.2 }}
      onClick={() => navigate(`/experience/${experience.id}`)}
      className="group bg-white rounded-2xl border border-border overflow-hidden cursor-pointer shadow-sm hover:shadow-xl transition-all duration-300"
    >
      {/* Header with icon */}
      <div className="p-5 pb-4">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
            <FontAwesomeIcon 
              icon={getExperienceTypeIcon(experienceType?.icon)} 
              className="text-primary text-2xl" 
            />
          </div>
          <div className="flex-1 min-w-0">
            <span className="text-xs font-semibold text-primary uppercase tracking-wide">Continue Planning</span>
            <h3 className="font-serif font-bold text-lg text-text-primary line-clamp-1 group-hover:text-primary transition-colors mt-1">
              {experience.title}
            </h3>
          </div>
        </div>
        
        <div className="flex items-center justify-between text-sm text-text-secondary mb-4">
          {daysUntil !== null && (
            <div className="flex items-center gap-1">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span>In {daysUntil} days</span>
            </div>
          )}
          <span className="bg-primary/10 text-primary px-3 py-1 rounded-full text-xs font-semibold">
            {experience.currentPhase || 'planning'}
          </span>
        </div>
        
        <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
          <div
            className="bg-gradient-to-r from-primary to-primary-light h-2 rounded-full transition-all"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
      
      {/* Footer with arrow */}
      <div className="px-5 pb-5">
        <div className="flex items-center justify-between text-sm font-semibold text-primary opacity-0 group-hover:opacity-100 transition-opacity">
          <span>Continue planning</span>
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </motion.div>
  );
}

